import type { GetMockInterviewVoucherItemResponse } from '../../../../../resources/@types/studyAgentSchema';
import useMockInterviewVoucherQuery from '../../../../queries/useMockInterviewVoucherQuery';
import type { UserState } from '../hero/interviewers';

/**
 * 이용권 상태로 히어로 CTA 분기(NEW / IN_PROGRESS / COMPLETED)를 판정한다.
 * - 이용권 없음 / 미사용 / 그 외 → NEW
 * - 진행중(ON_AIR) → IN_PROGRESS
 * - 보고서 생성완료(REPORT_GENERATED) → COMPLETED
 */
const resolveUserState = (voucher?: GetMockInterviewVoucherItemResponse): UserState => {
  if (voucher == null || !voucher.isUsed) {
    return 'NEW';
  }

  const { status } = voucher.mockInterview ?? {};

  if (status === 'ON_AIR') {
    return 'IN_PROGRESS';
  }

  if (status === 'REPORT_GENERATED') {
    return 'COMPLETED';
  }

  return 'NEW';
};

export const useAiInterviewHeroUserState = () => {
  const { data, isLoading } = useMockInterviewVoucherQuery({});
  const voucher = data?.items?.[0];

  return {
    userState: resolveUserState(voucher),
    isLoading,
  };
};
